import { useState } from "react";
import { useTranslation } from "react-i18next";

import IconButton from "../../packages/IconButton";
import WPSideNav from "../../packages/WPSideNav/WPSideNav";
import { WPVerticalTabsList } from "../../packages/WPTabs/WPVerticalTabs";
import WPTertiaryButton from "../../packages/WPTertiaryButton";

import {
  INTRODUCTION_TAB,
  LICENSE_TAB_LABEL_KEY_BY_ID,
} from "../../constants/LicenseManagement.constants";

import { DoubleLeftIcon, DoubleRightIcon } from "../../assets/icons";

const SideNav = ({
  userAccessibleLicenseTabIds,
  selectedLicenseTabId,
  setSelectedLicenseTabId,
  isCollapsed,
  setIsCollapsed,
}) => {
  const { t } = useTranslation();
  const [isToggleTooltipEnabled, setIsToggleTooltipEnabled] = useState(true);

  const licenseTabs = userAccessibleLicenseTabIds.map((licenseId) => ({
    id: licenseId,
    name: t(LICENSE_TAB_LABEL_KEY_BY_ID[licenseId]),
  }));

  licenseTabs.unshift({
    id: INTRODUCTION_TAB.id,
    name: t(INTRODUCTION_TAB.labelKey),
  });

  const handleToggle = () => {
    setIsToggleTooltipEnabled(false);
    setIsCollapsed((previousState) => !previousState);
  };

  const handleSideNavMouseMove = () => {
    if (!isToggleTooltipEnabled) {
      setIsToggleTooltipEnabled(true);
    }
  };

  return (
    <div
      className={`licensed-documentation__sidenav ${
        isCollapsed ? "licensed-documentation__sidenav--collapsed" : ""
      }`}
      onMouseMove={handleSideNavMouseMove}
    >
      {isCollapsed ? (
        <IconButton
          tooltip={isToggleTooltipEnabled ? t("ValueStrings.expand") : ""}
          placement="bottom"
          onClick={handleToggle}
        >
          <WPTertiaryButton icon={<DoubleRightIcon />} preventDefault={false} />
        </IconButton>
      ) : (
        <>
          <IconButton
            tooltip={isToggleTooltipEnabled ? t("ValueStrings.collapse") : ""}
            onClick={handleToggle}
            className="collapse-button"
          >
            <WPTertiaryButton
              icon={<DoubleLeftIcon />}
              preventDefault={false}
            />
          </IconButton>
          <WPSideNav>
            <WPVerticalTabsList
              tabs={licenseTabs}
              onTabClick={setSelectedLicenseTabId}
              activeTab={selectedLicenseTabId}
            />
          </WPSideNav>
        </>
      )}
    </div>
  );
};

export default SideNav;
